import {IComponentOptions} from "angular";
import {ILoadingServiceRootScope} from "../../loading/loading.service";

class LayoutController {
    private loading = false;

    /* @ngInject */
    constructor($rootScope: ILoadingServiceRootScope) {
        $rootScope.$watch("stateLoading", () => this.loading = $rootScope.stateLoading);
    }
}


export const LayoutComponent: IComponentOptions = {
    bindings: {
        currentUser: "<"
    },
    controller: LayoutController,
    template: require("./layout.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/widget/layout/layout.component.ts